import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link, browserHistory } from 'react-router'
import * as actions from '../../actions'
import cookie from 'react-cookie'
import InputProfile from '../componentKit2/InputProfile'
import { api, host, domen } from '../../config.js'
import CSSModules from 'react-css-modules'
import styles from './loginValidationForm.css'
import LogoLink from '../componentKit/LogoLink'
import BackgroundTester from '../componentKit2/BackgroundTester'
import classNames from 'classnames';
import CheckboxOfert from '../componentKit/CheckboxOfert'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

const defaultBg = <img className={styles.alfaBg} src="/assets/img/els/els-bg2.jpg" alt=""/>

const FB = window.FB

class LoginValidationForm extends Component {
  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.width = '300px'
    }
  }

  componentDidMount() {
    document.addEventListener('DOMContentLoaded', function () {
      window.addEventListener('message', function (event) {
        if (event.data.name === 'okAuth') {
          browserHistory.push({ pathname: '/social/ok', query: { code: event.data.code } })
        }
      }, false)
    }, false)
  }

  render() {

    const { handleSubmit, packageType, program, promo, siteSettings, smm} = this.props
    const isAlfa = domen.isAlfa
    const isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let bg = defaultBg
    let url  = isTele2Lk ? 'https://tele2lk.todayme.ru' : 'https://lk.todayme.ru';

    const isAccept = localStorage.getItem('accept');

    const tester = cookie.load('tester')
    let renderSmm = {}
    if(siteSettings.data){
      siteSettings.data.enabledSocialNetworks.forEach((item, idx) => {
        renderSmm[item] = true
      })
    }

    const loginVk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      window.location = `https://oauth.vk.com/authorize?client_id=6420905&scope=wall,offline&redirect_uri=${url}/social/vk&display=page&response_type=token&v=5.73`
    }

    const loginOk = () => {
      if (packageType) {
        cookie.save('packageType', packageType, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (program) {
        cookie.save('program', program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      if (promo) {
        cookie.save('promoName', promo, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
      }
      const urlOk = `https://connect.ok.ru/oauth/authorize?client_id=1264634880&scope=VALUABLE_ACCESS,LONG_ACCESS_TOKEN,PHOTO_CONTENT,GET_EMAIL&response_type=token&redirect_uri=${url}/social/ok`
      window.open(urlOk, 'Odnoklassniki', 'width=700,height=400')
    }

    const redirectFb = () => {
      let uri

      if (program && packageType) {
        uri = encodeURI(`${url}/social/fb?type=${packageType},${program},${promo}`)
      } else {
        uri = encodeURI(`${url}/social/fb`)
      }

      window.location = encodeURI('https://www.facebook.com/dialog/oauth?client_id=978521608971564&redirect_uri=' + uri + '&response_type=token')
    }

    const loginFb = () => {
      const self = this
      FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
          const token = response.authResponse.accessToken
          const userId = response.authResponse.userID
          const socialNetType = 3
          const payload = { userId, token, socialNetType }
          return fetch(`${api}/user/authenticate-social`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
          })
          .then(response => response.json())
          .then(json => {
            if (json.errorCode === 1 && json.data && json.data.authToken) {
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              self.props.setToken(json.data.authToken)
              browserHistory.push('/signup/pay')
            } else {
              redirectFb()
            }
          })
        } else {
         redirectFb()
        }
      }, { scope: 'email' })
    }

    const loginIn = () => {

    }
    const loginGp = () => {

    }
    return (
      <div className={classNames(styles.layoutEntry, {
        [styles.layoutEntrySmm] : smm
      })}>
        { !smm && <div className={styles.gridEntryHeader}>
            <div className={styles.gridCellTodaymeLogo}>
              {!isTele2Lk ? <LogoLink isAlfa={isAlfa}/> : null}
          </div>
        </div>}
        <div className={classNames(styles.entryMin, {
          [styles.entryMinSmm] : smm
        })}>
          <div className={isTele2Lk ? styles.entryInnerTele2: styles.entryInner}>
            <div className={styles.entryHeader}>
              {isTele2Lk ?
                <div className={styles.tele2Wrap}>
                  <img src="/assets/img/tele2/tele2_logo_black.png" className={styles.tele2Logo} alt=""/>
                  <h2 className={styles.entryTitleCenterTele2}>Спорт по другим правилам</h2>
                </div>
                :
                <h2 className={isAlfa ? styles.entryTitleCenterAlfa : styles.entryTitleCenter}>Войти в личный кабинет</h2>
              }
            </div>

            <form
              onSubmit={handleSubmit(this.props.onSubmit)}
              className={classNames(styles.entryBox, {
                [styles.entryBoxSmm] : smm
              })}>


              <Field smm={smm} name='email' id='login[1]' placeholder='Ваш e-mail' component={InputProfile} />
              <Field smm={smm} name='password' id='login[2]' placeholder='Ваш пароль' type='password' component={InputProfile} />


              {
                !isAccept &&

                <div className={styles.checkboxes}>
                    <Field isAccept={true} name='accept' title='Принять условия ' id='accept'
                           component={CheckboxOfert}/>
                </div>
              }

              <button type='submit' className={isTele2Lk ? styles.buttonSecondaryWideTele2 : styles.buttonSecondaryWide}>Войти</button>

              <ul className={styles.entryNavMtb20}>
                <li className={styles.entryNavItem}>
                  <Link className={styles.entryNavLink} to="/signup">Регистрация</Link>
                </li>
                <li className={styles.entryNavItem}>
                  <Link className={styles.entryNavLink} to="/restore">Забыли пароль?</Link>
                </li>
              </ul>
              {!isAlfa && !isTele2Lk && !isUnipro?
                <div>
                  <p className={styles.textCenterMb10}>Войти через социальные сети</p>
                  <ul className={styles.socialSignin}>
                    { renderSmm.FB && <li className={styles.socialSigninItemFb} onClick={loginFb}>
                      <svg className={styles.svgIconFb}>
                        <use xlinkHref="#fb"></use>
                      </svg>
                    </li>}
                    { renderSmm.VK && <li className={styles.socialSigninItemVk} onClick={loginVk}>
                      <svg className={styles.svgIconVk}>
                        <use xlinkHref="#vk"></use>
                      </svg>
                    </li>}
                    { renderSmm.OK &&<li className={styles.socialSigninItemOk} onClick={loginOk}>
                      <svg className={styles.svgIconOk}>
                        <use xlinkHref="#odnoklassniki"></use>
                      </svg>
                    </li>}
                    { renderSmm.IN &&<li className={styles.socialSigninItemIn} onClick={loginIn}>
                      <svg className={styles.svgIconIn}>
                        <use xlinkHref="#insta"></use>
                      </svg>
                    </li>}
                    { renderSmm.GP &&<li className={styles.socialSigninItemGp} onClick={loginGp}>
                      <svg className={styles.svgIconGp}>
                        <use xlinkHref="#g_plus"></use>
                      </svg>
                    </li>}
                  </ul>
                </div>
                : null }
            </form>

          </div>
        </div>

        {tester
          ? <BackgroundTester />
          : !smm ? <div className={styles.entryBg}>
            {bg}
            </div> : null
        }

      </div>
    )
  }
}

const validate = data => {
  const errors = {}

  if (!data.email) {
    errors.email = 'Email должен быть заполнен'
  } else if (!/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(data.email)) {
    errors.email = 'Email заполнен неправильно'
  }

  if (!data.password) {
    errors.password = 'Поле пароля должно быть заполнено'
  }

  return errors
}

LoginValidationForm = reduxForm({
  form: 'loginValidation',
  validate
})(LoginValidationForm)

const mapStateToProps = state => {
  let { program, packageType, promo, siteSettings } = state

  return {
    program,
    siteSettings,
    packageType,
    promo
  }
}

const mapDispatchToProps = dispatch => ({
  signup: bindActionCreators(actions.signup, dispatch),
  setToken: bindActionCreators(actions.setToken, dispatch)
})

LoginValidationForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginValidationForm)

export default CSSModules(LoginValidationForm, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/profile/LoginValidationForm.js